const LOCKED_FOCUS = 'locked';
const UNLOCKED_FOCUS = 'unlocked';

export {
  LOCKED_FOCUS,
  UNLOCKED_FOCUS,
};
